export default "__VITE_ASSET__DIXv3etr__"